export function isTaxDocumentEmitted(doc) {
  return doc?.status === 'EMITTED';
}

export function taxDocumentPdfFilename(doc, { prefix = 'factura', rol } = {}) {
  if (doc?.folio != null) return `${prefix}-${doc.folio}.pdf`;
  if (rol && rol !== '—') return `${prefix}-${rol}.pdf`;
  return `${prefix}-${doc?.id ?? 'documento'}.pdf`;
}
